import { Stack } from 'expo-router';

// Gives the `upgrade` segment its own layout so it registers as `upgrade`
// (not `upgrade/index`) in the parent navigator. The screen renders its own
// header/back, so keep the stack header hidden.
export default function UpgradeStackLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
    </Stack>
  );
}
